import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IPrivatePublication, privatePublicationsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

const PRIVATE_PUBLICATION_MODULE = 'privatePublication';

const searchModule = getSearchModule(privatePublicationsManager);
const dataObjectModule = getDataObjectsModule<IPrivatePublication>(privatePublicationsManager);

const privatePublicationModuleInstance = merge<unknown>(dataObjectModule, searchModule);
store.registerModule(PRIVATE_PUBLICATION_MODULE, privatePublicationModuleInstance);

export { PRIVATE_PUBLICATION_MODULE };
